import { z } from "zod";

/**
 * The one field a returner types at the gate: how much of this thing came off the lorry.
 *
 * The sheet asks with a text input, so what the form holds is a string — the coercion is what
 * turns it into the figure the booking routes are handed, and it is also what refuses a field
 * somebody cleared or filled with something that is not a number.
 *
 * There is no upper bound, for the reason `postReturnBookingJsonSchema` gives: sites swap material
 * between jobs, so more of an article can come back than that project's orders recorded. Whole
 * numbers are not demanded either, because a `numeric` balance holds a fraction and an article the
 * warehouse measures in metres comes back in metres. The carrier route is the stricter of the two
 * and keeps its own `.int()`, since half a pallet is not a thing anybody hands over.
 */
export const returnQuantitySchema = z.object({
	quantity: z.coerce.number().positive(),
});

export type ReturnQuantityFormSchema = z.infer<typeof returnQuantitySchema>;
